import { cn } from '../../../lib/utils.ts'
import { type IllustrationProps } from '../illustration.types.ts'

export function MoneyHouseIllustration({
  className,
  'aria-label': ariaLabel = 'Money house',
  'aria-hidden': ariaHidden,
  ...rest
}: IllustrationProps): React.ReactElement {
  return (
    <svg
      viewBox="0 0 80 80"
      role="img"
      aria-label={ariaHidden === true ? undefined : ariaLabel}
      aria-hidden={ariaHidden}
      xmlns="http://www.w3.org/2000/svg"
      className={cn('inline-block shrink-0', className)}
      {...rest}
    >
      <>
        <defs>
          <linearGradient
            id="money-house-paint0_linear_16538_41536"
            x1={77.077}
            x2={27.193}
            y1={45.613}
            y2={73.101}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#226322" />
            <stop offset={0.19} stopColor="#205E20" />
            <stop offset={0.39} stopColor="#1B511B" />
            <stop offset={0.61} stopColor="#143B14" />
            <stop offset={0.83} stopColor="#091C09" />
            <stop offset={1} />
          </linearGradient>
          <linearGradient
            id="money-house-paint1_linear_16538_41536"
            x1={75.416}
            x2={26.913}
            y1={41.395}
            y2={70.133}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#58B558" />
            <stop offset={0.21} stopColor="#55B055" />
            <stop offset={0.44} stopColor="#4CA34C" />
            <stop offset={0.68} stopColor="#3D8D3D" />
            <stop offset={0.92} stopColor="#296E29" />
            <stop offset={1} stopColor="#226322" />
          </linearGradient>
          <linearGradient
            id="money-house-paint2_linear_16538_41536"
            x1={74.192}
            x2={33.008}
            y1={48.453}
            y2={46.79}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#BBF5BB" />
            <stop offset={0.27} stopColor="#B8F3B8" />
            <stop offset={0.46} stopColor="#AFEDAF" />
            <stop offset={0.62} stopColor="#9FE39F" />
            <stop offset={0.77} stopColor="#89D589" />
            <stop offset={0.91} stopColor="#6DC36D" />
            <stop offset={1} stopColor="#58B558" />
          </linearGradient>
          <linearGradient
            id="money-house-paint3_linear_16538_41536"
            x1={8.311}
            x2={33.128}
            y1={66.193}
            y2={23.466}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#CCAE92" />
            <stop offset={0.07} stopColor="#D3BAA2" />
            <stop offset={0.21} stopColor="#E0CEBE" />
            <stop offset={0.36} stopColor="#EADED4" />
            <stop offset={0.53} stopColor="#F1E9E4" />
            <stop offset={0.72} stopColor="#F5EFED" />
            <stop offset={1} stopColor="#F7F2F0" />
          </linearGradient>
          <linearGradient
            id="money-house-paint4_linear_16538_41536"
            x1={19.429}
            x2={40.451}
            y1={38.264}
            y2={3.34}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D46953" />
            <stop offset={0.42} stopColor="#D36751" />
            <stop offset={0.6} stopColor="#D0634D" />
            <stop offset={0.75} stopColor="#CB5B45" />
            <stop offset={0.87} stopColor="#C4513A" />
            <stop offset={0.97} stopColor="#BA3C23" />
            <stop offset={1} stopColor="#B8361C" />
          </linearGradient>
          <linearGradient
            id="money-house-paint5_linear_16538_41536"
            x1={33.028}
            x2={54.302}
            y1={41.151}
            y2={59.569}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#CCAE92" />
            <stop offset={0.07} stopColor="#D3BAA2" />
            <stop offset={0.21} stopColor="#E0CEBE" />
            <stop offset={0.36} stopColor="#EADED4" />
            <stop offset={0.53} stopColor="#F1E9E4" />
            <stop offset={0.72} stopColor="#F5EFED" />
            <stop offset={1} stopColor="#F7F2F0" />
          </linearGradient>
          <linearGradient
            id="money-house-paint6_linear_16538_41536"
            x1={52.395}
            x2={51.069}
            y1={64.367}
            y2={54.786}
            gradientUnits="userSpaceOnUse"
          >
            <stop />
            <stop offset={0.15} stopColor="#352D26" />
            <stop offset={0.29} stopColor="#625446" />
            <stop offset={0.44} stopColor="#887461" />
            <stop offset={0.58} stopColor="#A68D76" />
            <stop offset={0.73} stopColor="#BB9F85" />
            <stop offset={0.87} stopColor="#C7AA8E" />
            <stop offset={1} stopColor="#CCAE92" />
          </linearGradient>
        </defs>
        <g id="money-house-Insurance=PVV, Generic=Money house">
          <g id="money-house-Group 221">
            <path
              id="money-house-Vector"
              fill="#000"
              d="m50.807 18.202 18.845 18.175v11.857l-40.61 10.044-.034-18.746z"
            />
            <path
              id="money-house-Vector_2"
              fill="#000"
              d="M28.957 58.657a.37.37 0 0 1-.184-.06.3.3 0 0 1-.11-.227l-.033-18.825c0-.076.033-.16.084-.21l21.78-21.43a.3.3 0 0 1 .41 0L69.75 36.159a.3.3 0 0 1 .092.21v11.915a.296.296 0 0 1-.227.287l-40.59 10.078h-.067zm.26-18.994.034 18.32 40.003-9.935V36.495L50.703 18.529z"
            />
            <path
              id="money-house-Vector_3"
              fill="url(#money-house-paint0_linear_16538_41536)"
              d="M70.846 46.369 29.008 68.98v3.477c23.196-7.314 31.716-15.735 44.614-24.543 0 0-.856-.571-2.768-1.545z"
            />
            <path
              id="money-house-Vector_4"
              fill="#000"
              d="M28.924 72.835a.294.294 0 0 1-.294-.294v-3.473c0-.11.067-.21.16-.26l41.987-22.594a.3.3 0 0 1 .277 0c1.91.974 2.777 1.536 2.811 1.56a.294.294 0 0 1 .008.487c-2.482 1.687-4.83 3.381-7.103 5.017-9.72 7.006-18.893 13.625-37.753 19.54-.034.008-.059.017-.093.017m.303-3.591v2.894C47.725 66.282 56.815 59.73 66.425 52.8a345 345 0 0 1 6.742-4.773 37 37 0 0 0-2.239-1.225l-41.7 22.433z"
            />
            <path
              id="money-house-Vector_5"
              fill="url(#money-house-paint1_linear_16538_41536)"
              d="M70.67 42.777 29.008 65.346v3.708c23.196-7.34 31.716-15.793 44.614-24.634 0 0-.915-.606-2.952-1.643"
            />
            <path
              id="money-house-Vector_6"
              fill="#000"
              d="M28.924 69.243a.292.292 0 0 1-.294-.293v-3.678c0-.11.067-.21.16-.26l41.81-22.39a.28.28 0 0 1 .27 0c2.036 1.029 2.953 1.63 2.995 1.648a.292.292 0 0 1 .008.485c-2.482 1.68-4.83 3.369-7.103 5-9.72 6.98-18.893 13.577-37.753 19.471-.034.008-.059.017-.093.017m.303-3.796v3.11c18.498-5.836 27.588-12.365 37.198-19.271a345 345 0 0 1 6.742-4.757c-.43-.251-1.22-.71-2.424-1.313z"
            />
            <path
              id="money-house-Vector_7"
              fill="url(#money-house-paint2_linear_16538_41536)"
              d="M29.033 44.516c8.772-4.264 16.83-9.374 24.01-15.539 0 0 2.64 3.912 9.534 6.61 7.824 3.065 11.045 5.201 11.045 5.201-12.898 8.779-21.418 17.189-44.614 24.485l.033-20.749z"
            />
            <path
              id="money-house-Vector_8"
              fill="#DEFFDE"
              d="M43.238 54.971c5.04-1.616 8.328-5.415 7.344-8.485-.985-3.07-5.869-4.249-10.91-2.632-5.04 1.616-8.327 5.415-7.342 8.485.984 3.07 5.868 4.249 10.908 2.632"
            />
            <path
              id="money-house-Vector_9"
              fill="#58B558"
              d="M38.836 56.002c-3.224 0-5.873-1.2-6.717-3.34-.43-1.081-.354-2.307.211-3.541 1.055-2.3 3.637-4.345 6.902-5.487 5.164-1.792 10.37-.684 11.618 2.486.43 1.082.355 2.307-.21 3.542-1.055 2.299-3.637 4.345-6.902 5.486-1.67.583-3.35.862-4.902.862zm5.34-12.647c-1.493 0-3.121.27-4.75.837-3.071 1.074-5.585 3.052-6.564 5.174-.498 1.082-.565 2.147-.203 3.077 1.131 2.874 6.008 3.837 10.876 2.138 3.071-1.073 5.586-3.051 6.564-5.173.498-1.082.566-2.147.203-3.077-.751-1.91-3.164-2.976-6.126-2.976"
            />
            <path
              id="money-house-Vector_10"
              fill="#DEFFDE"
              d="M58.31 33.566a14.8 14.8 0 0 1-3.495 1.749c-3.687 1.285-7.39 1.059-9.55-.362a102 102 0 0 0 7.67-5.976s1.746 2.597 5.375 4.59"
            />
            <path
              id="money-house-Vector_11"
              fill="#58B558"
              d="M50.1 36.341c-1.903 0-3.63-.419-4.889-1.24a.28.28 0 0 1-.134-.244c0-.1.042-.184.126-.243a100 100 0 0 0 7.631-5.946.3.3 0 0 1 .235-.067c.084.008.16.059.202.126.016.025 1.752 2.558 5.266 4.486a.28.28 0 0 1 .151.244c0 .1-.042.2-.126.26a14.9 14.9 0 0 1-3.555 1.777c-1.644.57-3.338.856-4.898.856zm-4.193-1.517c2.18 1.19 5.61 1.24 8.898.1a14.5 14.5 0 0 0 3.02-1.442c-2.751-1.602-4.336-3.48-4.856-4.168a103 103 0 0 1-7.07 5.518z"
            />
            <path
              id="money-house-Vector_12"
              fill="#DEFFDE"
              d="M66.153 36.925c5.246 2.304 7.469 3.808 7.469 3.808-2.723 1.896-5.254 3.783-7.768 5.636-1.416-.527-2.481-1.42-2.948-2.627-.849-2.21.533-4.862 3.247-6.825z"
            />
            <path
              id="money-house-Vector_13"
              fill="#58B558"
              d="M65.815 46.558s-.068 0-.102-.017c-1.581-.566-2.672-1.514-3.163-2.737-.887-2.214.449-4.968 3.4-7.023a.32.32 0 0 1 .287-.034c5.294 2.239 7.535 3.695 7.628 3.753.084.05.135.142.135.241 0 .1-.05.192-.127.242a281 281 0 0 0-7.018 4.9l-.863.617a.32.32 0 0 1-.178.058m.338-9.203c-2.63 1.88-3.83 4.318-3.061 6.24.414 1.024 1.336 1.84 2.672 2.347l.735-.524a285 285 0 0 1 6.664-4.652c-.829-.49-3.061-1.73-7.01-3.411"
            />
            <path
              id="money-house-Vector_14"
              fill="#000"
              d="M28.925 65.643a.295.295 0 0 1-.295-.294l.034-20.849c0-.11.067-.21.168-.26 9.074-4.42 17.155-9.655 24.032-15.572a.28.28 0 0 1 .227-.067c.084.008.16.059.202.126.025.042 2.694 3.889 9.436 6.532 7.794 3.055 11.102 5.226 11.136 5.252a.295.295 0 0 1 .008.488c-2.483 1.691-4.831 3.392-7.104 5.033C57.047 53.06 47.872 59.7 29.017 65.634c-.034.009-.059.017-.093.017zm.328-20.958-.034 20.26c18.51-5.876 27.592-12.45 37.205-19.393a345 345 0 0 1 6.742-4.789c-1.06-.631-4.394-2.508-10.648-4.957-5.968-2.34-8.779-5.547-9.511-6.49-6.818 5.833-14.806 11.001-23.754 15.37"
            />
            <path
              id="money-house-Vector_15"
              fill="url(#money-house-paint3_linear_16538_41536)"
              d="M29.008 72.457V39.589l-23.63-9.856v31.36z"
            />
            <path
              id="money-house-Vector_16"
              fill="url(#money-house-paint4_linear_16538_41536)"
              d="M27.164 8.372 5.378 29.697l23.55 9.866 21.82-21.308z"
            />
            <path
              id="money-house-Vector_17"
              fill="url(#money-house-paint5_linear_16538_41536)"
              d="M35.867 40.509a131 131 0 0 1-6.86 4.013l19.23 13.19 6.858-4.014z"
            />
            <path
              id="money-house-Vector_18"
              fill="url(#money-house-paint6_linear_16538_41536)"
              d="M48.29 63.631v1.075c2.875-1.642 4.437-2.463 6.806-3.935v-7.219l-6.806 4.02z"
            />
            <path
              id="money-house-Vector_19"
              fill="#000"
              d="M48.274 65.084a.34.34 0 0 1-.152-.042.28.28 0 0 1-.143-.252v-6.921l-19.222-13.02a.28.28 0 0 1-.126-.26.3.3 0 0 1 .151-.244 134 134 0 0 0 6.888-3.981.31.31 0 0 1 .32 0l19.357 13.112c.085.05.127.142.127.243v7.165c0 .1-.05.202-.144.252-1.762 1.067-3.102 1.806-4.805 2.747-.632.352-1.324.73-2.108 1.167a.3.3 0 0 1-.143.034M29.482 44.63l18.952 12.834c.085.05.127.143.127.244v6.577l1.669-.924c1.652-.907 2.959-1.63 4.645-2.646V53.88L35.805 40.96a147 147 0 0 1-6.331 3.67z"
            />
            <path
              id="money-house-Vector_20"
              fill="#000"
              d="M28.933 72.835a.3.3 0 0 1-.126-.026L5.169 61.406A.3.3 0 0 1 5 61.137v-31.47c0-.076.034-.152.084-.21L26.952 8.077a.28.28 0 0 1 .32-.059l23.672 9.9a.28.28 0 0 1 .177.218.3.3 0 0 1-.084.269L29.228 39.683V72.54c0 .101-.05.194-.135.253a.27.27 0 0 1-.16.042M5.59 60.952 28.638 72.07V39.557a.33.33 0 0 1 .084-.21l21.581-21.059-23.081-9.655-21.64 21.151v31.16z"
            />
          </g>
        </g>
      </>
    </svg>
  )
}
